'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propertiesMap = undefined;
exports.calculatePrices = calculatePrices;
exports.sortImages = sortImages;
exports.addPublicationToEstablishment = addPublicationToEstablishment;
exports.updateEstablishment = updateEstablishment;
exports.createEstablishment = createEstablishment;

var _helpers = require('../helpers');

var _config = require('../config');

var _Publication = require('./Publication');

var _rating = require('../helpers/rating');

var _constants = require('../constants');

// Returns an array of the ids inside the objects of an objects array
function _getIdsArray(arr, prop) {
  if (typeof arr === 'undefined') return [];

  var ids = [];

  for (var i = 0; i < arr.length; i++) {
    ids.push(arr[i][prop]);
  }
  return ids;
}

var propertiesMap = {
  id: 'id',
  title: function title(_ref) {
    var _title = _ref.title;

    if (!_title || typeof _title === 'string') return null;
    return _title[(0, _config.getConfig)('DOMAIN_CULTURE')] || _title[_constants.CULTURE_FALLBACK[(0, _config.getConfig)('DOMAIN_CULTURE')]] || null;
  },
  titlePreposition: 'title_preposition',
  rating: function rating(item) {
    return item.rating ? Math.round(item.rating) : 0;
  },
  combinedRating: function combinedRating(item) {
    return item.combined_rating ? Math.round(item.combined_rating * 10) / 10 : 0;
  },
  ranking: function ranking(item) {
    return item.num_comments > 0 ? item.ranking : 0;
  },
  recommendation: null,
  numberOfImages: 'num_images',
  numberOfLikes: 'num_favorites',
  numberOfComments: 'num_comments',
  partnersComments: function partnersComments(item) {
    return item.partners_comments || {};
  },
  numberOfClickouts: 'num_clickouts',
  type: 'category_id',
  rooms: 'num_rooms',
  address: 'address',
  city: 'city',
  region: 'region',
  country: 'country',
  area: 'area',
  latitude: 'latitude',
  longitude: 'longitude',
  maxGuests: 'max_guests',
  minStay: 'min_stay',
  neighbourhoods: function neighbourhoods(item) {
    return _getIdsArray(item.neighbourhoods, 'id');
  },
  pois: function pois(item) {
    return _getIdsArray(item.pois, 'id');
  },
  firstImage: function firstImage(item) {
    return item.image.medium;
  },
  images: 'images',
  features: 'features',
  minDayPrice: 'price_per_day',
  maxDayPrice: 'price_per_day',
  minTotalPrice: 'price',
  maxTotalPrice: 'price',
  cheapestPartner: 'partner_id',
  discount: null,
  partners: function partners(item) {
    return item.matching_publications ? item.matching_publications.map(function (match) {
      return (0, _Publication.createPublicationFromMatchingPublications)(match);
    }) : [];
  },
  polygons: 'polygons',
  partnerRating: 'partner_rating',
  licence: 'licence'
};

exports.propertiesMap = propertiesMap;
function calculateAvailability(estb) {
  return estb.cheapestPartner && estb.partners.find(function (publication) {
    return publication.partner_id === estb.cheapestPartner;
  }).instantly_booking ? _constants.AVAILABILITY.INSTANTLY : _constants.AVAILABILITY.UNDER_DEMAND;
}

function isCancellationPolicyAvailable(partners) {
  if (!partners[0].cancellation_policy) return false;
  return partners[0].cancellation_policy['100'] !== undefined ? _constants.CANCELLATION_POLICY.FULL : _constants.CANCELLATION_POLICY.PARTIAL;
}

function calculateDiscount(estb) {
  var priceSaved = estb.minDayPrice ? estb.maxDayPrice - estb.minDayPrice : 0;
  return priceSaved > 0 ? Math.round(priceSaved / estb.maxDayPrice * 100) : 0;
}

function calculatePrices(estb) {
  var allPartners = (0, _config.getConfig)('PARTNERS');
  var partners = (0, _Publication.findPrices)(estb.partners, allPartners);
  if (partners) {
    estb.minDayPrice = partners[0].price_per_day || null;
    estb.minTotalPrice = partners[0].price_total || null;
    estb.maxDayPrice = partners[partners.length - 1].price_per_day || null;
    estb.maxTotalPrice = partners[partners.length - 1].price_total || null;
    estb.cheapestPartner = partners[0].partner_id;
    estb.qualityScore = partners[0].quality_score;
    estb.discount = calculateDiscount(estb);
    estb.partners = (0, _Publication.sortPublications)(estb.partners, allPartners);
    estb.availability = calculateAvailability(estb);
    estb.cancellationPolicy = isCancellationPolicyAvailable(partners);
    estb.images = sortImages(estb.images, allPartners[partners[0].partner_id].name);
  }
  return estb;
}

function sortImages(images, partner) {
  if (!images[0].partners || !images[1] || !images[1].partners) return images;
  var img = images.find(function (image) {
    return image.partners && image.partners.indexOf(partner) >= 0;
  });
  if (!img) return images;
  images.splice(images.indexOf(img), 1);
  images.splice(0, 0, img);
  return images;
}

function addPublicationToEstablishment(publication, estb, dateArrival) {
  // find price partner in Establishment partners
  var pIndex = estb.partners.findIndex(function (partnr) {
    return partnr.partner_id === publication.partner_id;
  });

  if (pIndex >= 0) {
    // Price partner found in Establishment partners
    Object.assign(estb.partners[pIndex], (0, _Publication.createPublication)(publication, dateArrival));
  } else {
    // Price partner NOT found in Establishment partners
    // Create new Partner
    estb.partners.push((0, _Publication.createPublication)(publication, dateArrival));
  }

  return updateEstablishment(estb);
}

function updateEstablishment(establishment) {
  return (0, _rating.calculateRating)(calculatePrices(establishment));
}

// Creates a new establishment based on a publication
function createEstablishment(publication) {
  // Establishment partners
  if (typeof publication === 'undefined') {
    console.warn('No Establishment to create');
    return false;
  }
  var mapPub = (0, _helpers.definePropertiesMap)(propertiesMap);
  var parsedEstablishment = mapPub(publication);
  return updateEstablishment(parsedEstablishment);
}